import {Tag} from 'common/components'
import {formatDate} from 'common/helpers'
import { DrawdownStatus } from '..'
import { DRAWDOWNSTATUS, DRAWDOWN_REQUEST_STATUS_NAME } from 'modules/request/constants.drawdown'

interface DrawdownTagProps {
  isBorrower?: boolean
  noIcon?: boolean
  transparent?: boolean
  status: DrawdownStatus
  updatedAt?: string
}

/**
 * Drawdown 状态标签
 * @param param0 
 * @returns 
 */
export default function DrawdownTag({
  isBorrower,
  noIcon,
  transparent,
  status,
  updatedAt,
}: DrawdownTagProps) {
  const isBorrowerPending =
    isBorrower &&
    (status === DRAWDOWNSTATUS.DOCUMENT_CHECK ||
      status === DRAWDOWNSTATUS.FINAL_APPROVAL ||
      status === DRAWDOWNSTATUS.APPROVED)

  const color = isBorrowerPending
    ? 'warning'
    : status === DRAWDOWNSTATUS.APPROVED || 
      status === DRAWDOWNSTATUS.CONFIRMED || 
      status === DRAWDOWNSTATUS.RECEIVED
    ? 'success'
    : status === DRAWDOWNSTATUS.DECLINED
    ? 'grey'
    : undefined

  const icon = isBorrowerPending
    ? 'shield'
    : status === DRAWDOWNSTATUS.DOCUMENT_CHECK
    ? 'file'
    : status === DRAWDOWNSTATUS.DECLINED
    ? 'close'
    : 'check'

  const label = isBorrowerPending
    ? status === DRAWDOWNSTATUS.APPROVED
      ? 'Pending your confirmation'
      : 'Pending approval…'
    : DRAWDOWN_REQUEST_STATUS_NAME[status]

  return (
    <Tag
      transparent={transparent}
      color={color}
      icon={noIcon ? undefined : icon}
    >
      {label}
      {status === DRAWDOWNSTATUS.RECEIVED &&
        updatedAt &&
        ` ${formatDate(updatedAt, 'sixth')}`}
    </Tag>
  )
}
